(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Downloadable Resources via Resource Cards
 *
 * Must have the following:
 * @param .js-resource
 * @description top-level container for resource item
 * 
 * @param "data-restricted" attribute
 * @description must be set to True or False via get_field( 'resource_is_gated' )
 * 
 * @param "data-resource" attribute
 * @description  must be set on .js-resource to the ID of the resouce (ie; data-resource="7201")
 * 
 * @param .js-resource-download-btn
 * @description .js-resource item must have a download button/link with this class
 */
var DownloadPopup =
/*#__PURE__*/
function () {
  function DownloadPopup() {
    _classCallCheck(this, DownloadPopup);

    // Check if exists and initialize
    this.$resources = $('.js-resource');

    if (this.$resources.length > 0) {
      this.init();
    }
  }

  _createClass(DownloadPopup, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('resources initialized...');
      this.modal_placeholder_image_url = 'https://citynaturopathic.ca/wp-content/uploads/2022/08/pixel.jpg';
      this.modal = document.getElementById('resource-download-popup');
      this.modal.addEventListener("x_modal:close", function () {
        _this.resetModal();
      });
      this.$optin_form = $('#fluentform_4'); // FF Optin Form

      this.$resources.each(function (index, resource) {
        var $download_button = $(resource).find('.js-resource-download-btn');
        $download_button.on('click', function (e) {
          // e.preventDefault();
          var $resource_card = $(e.currentTarget).closest('.js-resource');

          _this.downloadButtonClick($resource_card);
        });
      });
    }
  }, {
    key: "downloadButtonClick",
    value: function downloadButtonClick($resource) {
      var _this2 = this;

      var resource_id = $resource.data('resource');
      $.ajax({
        url: resources.ajax_url,
        data: {
          'action': 'get_annex_resource',
          'resource_id': resource_id
        },
        success: function success(data) {
          var resource_data = JSON.parse(data); // console.log(resource_data);

          if ($resource.data('restricted') == 'False') {
            window.open(resource_data['url'], 'blank');
          }

          if ($resource.data('restricted') && resource_data['logged_in']) {
            window.open(resource_data['url'], 'blank');

            _this2.populatePopUp(resource_data);
          }

          if ($resource.data('restricted') && !resource_data['logged_in']) {
            _this2.populatePopUp(resource_data);
          }
        },
        failure: function failure(error) {
          window.alert('Error: ' + error);
        }
      });
    }
  }, {
    key: "populatePopUp",
    value: function populatePopUp(resource_data) {
      console.log(resource_data);
      var $modal = $('#resource-download-popup');
      $modal.find('input[name="dl_resource_name"').val(resource_data['name']);
      $modal.find('.resource-name').text(resource_data['name']);
      $modal.find('.resource-image').attr('srcset', '');
      $modal.find('.resource-image').attr('src', resource_data['image']);
      xOpenModal('resource-download-popup');
      this.$optin_form.on('fluentform_submission_success', function () {
        setTimeout(function () {
          window.open(resource_data['url']);
          location.reload();
        }, 2000);
      });
    }
  }, {
    key: "resetModal",
    value: function resetModal() {
      console.log('resetting modal...');
      var $modal = $('#resource-download-popup');
      $modal.find('input[name="dl_resource_name"').val("");
      $modal.find('.resource-name').text('Resource');
      $modal.find('.resource-image').attr('srcset', '');
      $modal.find('.resource-image').attr('src', this.modal_placeholder_image_url);
    }
  }]);

  return DownloadPopup;
}();

var _default = DownloadPopup;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

var _downloadables = _interopRequireDefault(require("./modules/downloadables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
window.$ = jQuery;
$(document).ready(function () {
  var downloadPopUps = new _downloadables.default();
});

},{"./modules/downloadables":1}]},{},[2]);
